import { useEffect } from 'react';
import { useQuery, useLazyQuery } from '@apollo/client';

import Head from 'components/common/markup/Head';
import Navbar from 'components/common/markup/Navbar';
import Content from 'components/common/markup/Content';
import Footer from 'components/common/markup/Footer';

import AllSpeakers from 'components/marathon21/AllSpeakers';

import MenuLogo from 'components/marathon21/MenuLogo';

import settings from 'json/marathon21.settings.json';

import initializeApollo, { addApolloState } from 'apollo-client';

import QUERY_EVENT from 'graphql/event.graphql';

import {
  GetEventQuery,
  GetEventQueryVariables,
  EventType,
} from 'graphql/types';

function SpeakersPage() {
  const { data } = useQuery<GetEventQuery>(QUERY_EVENT, {
    variables: {
      slug: settings.slug,
    } as GetEventQueryVariables,
  });
  const [fetchEvent, { data: cityData }] = useLazyQuery<GetEventQuery>(
    QUERY_EVENT,
    {
      variables: {
        slug: settings.cities[0].value,
      } as GetEventQueryVariables,
    }
  );

  const event = data?.eventBySlug as EventType;

  const cityEvent = cityData?.eventBySlug as EventType;

  const handleCityClick = (city: string) => {
    fetchEvent({ variables: { slug: city } });
  };

  useEffect(() => {
    fetchEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Head
        metaData={{
          title:
            'Спикеры II Марафона "Новое Знание" от Российского Общества Знание',
          description: event?.description,
        }}
        shareImage="/marathon21/share.jpeg"
      />
      <Navbar
        menuItems={settings.menu}
        desktopLogo
        customContent={() => <MenuLogo />}
      />
      <Content>
        <AllSpeakers
          onFilterItemClick={handleCityClick}
          speakers={cityEvent?.speakers || []}
        />
      </Content>
      <Footer />
    </>
  );
}

export async function getServerSideProps() {
  const apolloClient = initializeApollo();

  try {
    await apolloClient.query({
      query: QUERY_EVENT,
      variables: { slug: settings.slug },
    });
  } catch (err) {
    console.log(err);
  }

  try {
    await apolloClient.query({
      query: QUERY_EVENT,
      variables: { slug: settings.cities[0].value },
    });
  } catch (err) {
    console.log(err);
  }

  return addApolloState(apolloClient, {
    props: {},
  });
}

export default SpeakersPage;
